import { useSelector } from "react-redux";

export function usePermissions(perm: string | string[]): boolean | boolean[] {
  const orgPermissions: string[] = useSelector((state: any) => state.org.orgPermissions) ?? []
  const appPermissions: string[] = useSelector((state: any) => state.apps.selectedApp.permissions ?? [])

  if (typeof perm === "string") {
    return orgPermissions.includes(perm) || appPermissions.includes(perm)
  }

  if (Array.isArray(perm)) {
    const permResult: boolean[] = []
    perm.forEach(p => {
      permResult.push(orgPermissions.includes(p) || appPermissions.includes(p))
    })
    return permResult
  }

  return false
}
